import { DaoService } from "./DaoService";

export class ConfigurationService extends DaoService {

    static CLASS_NAME = "App\\Models\\Configuration";
    
    static getInstance() {
        return super.getInstance('configuration');
    }

    get() {
        return ConfigurationService.get(`${this.prefix}/get`);
    }

}